import getMapViewportDistance from 'helpers/map/getMapViewportDistance'

/**
 * Gets the location for a new device marker
 *
 * @param {google.maps.Map} map - the map object to use for calculations
 * @param {google.maps.LatLng} controllerLocation - the location of the door controller
 * @param {Number} headingCounter - the current device heading counter
 * @param {Number} scale - optional, the scale multiplier to use
 * @return {google.maps.LatLng} Location for new device
 */

export default (map, controllerLocation, headingCounter, scale = 0.25) => {
  const distance = scale * Math.min(...[getMapViewportDistance(map, false), getMapViewportDistance(map), 80].filter(d => !!d))

  return google.maps.geometry.spherical.computeOffset(controllerLocation, distance, headingCounter).toJSON()
}



// WEBPACK FOOTER //
// ./src/helpers/accessControl/getNewDeviceLocation.js